module.exports = __webpack_public_path__ + "img/Switzerland.684370ff.png";